'use strict';

(function () {
  'use strict';

  angular.module('msWidgets').directive('msPlainTextView', msPlainTextView);

  msPlainTextView.$inject = [];

  function msPlainTextView() {
    var directive = {
      templateUrl: 'widgets/templates/media/plain_text_view.html',
      link: link,
      restrict: 'A'
    };
    return directive;

    function link(scope) {
      scope.togglePlainText = function () {
        scope.showPlainText = !scope.showPlainText;
      };
    }
  }
})();